import React from "react";
import { useIsMobile } from "../../hooks/useIsMobile";
import styles from "./kanban.module.css";

/**
 * Shared Kanban board chrome (Cortex Console Design System & Consistency
 * Pass, CCDS-01/02). Wraps the caller's existing columns container - the
 * container itself keeps its own pre-existing data-testid, unchanged.
 */
export type KanbanBoardProps = {
  /** The pre-existing testid the columns container must keep (e.g. "agents-columns"). */
  columnsTestId: string;
  children: React.ReactNode;
};

export function KanbanBoard({ columnsTestId, children }: KanbanBoardProps) {
  // CCDS-06: viewport mode via the existing useIsMobile()/compactShellMediaQuery
  // infrastructure only - no new breakpoint constant or detection mechanism.
  const isMobile = useIsMobile();
  return (
    <div
      className={styles.board}
      data-testid="kanban-board"
      data-mobile-layout={isMobile ? "true" : "false"}
    >
      <div className={styles.columns} data-testid={columnsTestId}>
        {children}
      </div>
    </div>
  );
}
